import React, { createContext, useContext } from 'react'

import { useWishlistStateHook } from '../../hooks'

import type { WishlistStateType } from '../../types'

const WishlistStateContext = createContext<WishlistStateType | undefined>(undefined)

/**
 * Wishlist Provider - THIN wrapper that provides wishlist context
 * All business logic is in the composition hook (useWishlistStateHook)
 */
export function WishlistProvider({ children }: { children: React.ReactNode }) {
  const value = useWishlistStateHook()

  // React 19: Direct context syntax (no .Provider)
  return (
    <WishlistStateContext value={value}>
      {children}
    </WishlistStateContext>
  )
}

export function useWishlistState(): WishlistStateType {
  const context = useContext(WishlistStateContext)
  if (context === undefined) {
    throw new Error('useWishlistState must be used within a WishlistProvider')
  }
  return context
}
